import proxy from "api/proxy";
import { validateForm } from "tools/form";

export const storeConvert = (store) => {
  // Convert Map values into Array
  for (let [key, val] of Object.entries(store)) {
    if (val instanceof Map) {
      let childRecords = [];
      for (let rec of val.values()) {
        for (let [k, v] of Object.entries(rec)) {
          if (v && v.id) {
            rec[k] = v.id;
          }
        }
        childRecords.push(rec);
      }
      store[key] = childRecords;
    }
  }
  return store;
};

export const clientRemove = async (model, recId) => {
  const toRemove = {
    ids: [recId],
    model: model,
  };
  const { data } = await proxy.remove(toRemove);
  return data;
};

export const clientUpdate = async (
  model,
  storeData,
  storeRequired,
  record,
  fieldsNames,
) => {
  let res = {
    record: {},
    msg: "board.record_saved",
    type: "msgInfo",
  };
  let _storeData;
  if (record) {
    let store = {};
    for (const sr of storeRequired) {
      store[sr] = record[sr];
    }
    _storeData = { ...store, ...storeData };
  } else {
    _storeData = storeData;
  }

  let isValid = await validateForm("update", _storeData, storeRequired);
  if (isValid === "ok") {
    const rec_id = storeData.id;
    delete storeData.id;
    let storeJson = {};
    for (const [k, v] of Object.entries(storeData)) {
      if (v instanceof Map) {
        storeJson[k] = Array.from(v.values());
      } else {
        storeJson[k] = v;
      }
    }
    const data = {
      id: rec_id,
      model: model,
      record_data: storeJson,
      fields: fieldsNames,
    };

    const record = await proxy.save(data);
    if (record) {
      res["record"] = record;
      res["id"] = record.id;
    }
  } else {
    res["msg"] = isValid;
    res["type"] = "msgWarning";
  }
  return res;
};

export const clientAdd = async (
  model,
  storeData,
  storeRequired,
  fieldsNames,
) => {
  let res = {
    record: {},
    msg: "board.record_created",
    type: "msgInfo",
  };

  const isValid = await validateForm("create", storeData, storeRequired);
  if (isValid === "ok") {
    const record = await proxy.create(model, storeData, fieldsNames);
    res["record"] = record;
    res["id"] = record.id;
  } else {
    res["msg"] = isValid;
    res["type"] = "msgWarning";
  }

  return res;
};

export async function searchSelection(model, domain, fields, limit) {
  if (!fields) {
    fields = ["id", "rec_name"];
  }
  let items = new Map();
  const records = await proxy.search(model, domain, fields, limit);
  for (let r of records) {
    items.set(r.id, {
      key: r.id,
      value: r.id,
      text: r.rec_name || r.name,
      record: r,
    });
  }
  return items;
}

export const getRequired = (fields, record) => {
  let required = [];
  // const nested_fields = ["many2one", "one2many"];
  for (let [k, v] of Object.entries(fields)) {
    if (typeof v.required === "function") {
      const req = v.required(record);
      if (req) {
        required.push(k);
      }
    } else if (v.required) {
      required.push(k);
    }
  }
  return required;
};

export const factoryFields = (ctxView) => {
  let fieldsNames = [];
  for (let [k, v] of Object.entries(ctxView["webfields"])) {
    if (v.type === "one2many") {
      const subfields = Object.keys(v.ctxView.webfields);
      for (let f of subfields) {
        fieldsNames = fieldsNames.concat([k + "." + f]);
      }
    } else if (v.type !== "button") {
      fieldsNames.push(k);
    }
  }
  return fieldsNames;
};

export async function triggerMethod(model, method, record, required) {
  let res;
  let isValid = "ok";
  if (required && Object.keys(record).length > 1) {
    isValid = await validateForm("create", record, required);
  }
  if (isValid === "ok") {
    // const storeRec = await storeConvert(record);
    const ids = [record.id];
    const args = { model, method, ids };
    res = await proxy.buttonMethod(args);
  } else {
    res = {
      record: null,
      type: "warning",
      open_modal: true,
      msg: isValid,
    };
  }
  return res;
}

export async function findActiveModules(target) {
  const model = "ir.module";
  const domain = [["name", "in", target]];
  const fields_names = ["name", "state"];
  const { data } = await proxy.search(model, domain, fields_names);
  let res = {};
  data.forEach((mod) => {
    res[mod.name] = mod.state;
  });
  return res;
}
export function splitFullName(name, record, { setName = true } = {}) {
  if (!name) return;

  if (setName) {
    record.store.name = name;
    record.active.name = name;
  }

  const parts = name.trim().split(/\s+/);
  let first_name = "";
  let second_name = "";
  let first_family_name = "";
  let second_family_name = "";

  if (parts.length >= 4) {
    first_family_name = parts[parts.length - 2];
    second_family_name = parts[parts.length - 1];
    const names = parts.slice(0, -2);
    first_name = names[0] || "";
    second_name = names.slice(1).join(" ");
  } else if (parts.length === 3) {
    first_name = parts[0];
    first_family_name = parts[1];
    second_family_name = parts[2];
  } else if (parts.length === 2) {
    first_name = parts[0];
    first_family_name = parts[1];
  } else if (parts.length === 1) {
    first_name = parts[0];
  }

  record.store.first_name = first_name;
  record.active.first_name = first_name;
  record.store.second_name = second_name;
  record.active.second_name = second_name;
  record.store.first_family_name = first_family_name;
  record.active.first_family_name = first_family_name;
  record.store.second_family_name = second_family_name;
  record.active.second_family_name = second_family_name;
}

export function splitFullNameV1(name, record, { setName = true } = {}) {
  if (!name) return;

  const trimmed = name.trim();
  if (!trimmed) return;

  if (setName && record) {
    record.name = trimmed;
    if (record.store) record.store.name = trimmed;
    if (record.active) record.active.name = trimmed;
  }

  const parts = trimmed.split(/\s+/);
  let first_name = "";
  let second_name = "";
  let first_family_name = "";
  let second_family_name = "";

  if (parts.length >= 4) {
    first_family_name = parts[parts.length - 2];
    second_family_name = parts[parts.length - 1];
    const names = parts.slice(0, -2);
    first_name = names[0] || "";
    second_name = names.slice(1).join(" ") || "";
  } else if (parts.length === 3) {
    first_name = parts[0] || "";
    second_name = parts[1] || "";
    first_family_name = parts[2] || "";
    second_family_name = "";
  } else if (parts.length === 2) {
    first_name = parts[0] || "";
    second_name = "";
    first_family_name = parts[1] || "";
    second_family_name = "";
  } else if (parts.length === 1) {
    first_name = parts[0] || "";
    second_name = "";
    first_family_name = "";
    second_family_name = "";
  }

  if (record) {
    record.first_name = first_name;
    record.second_name = second_name;
    record.first_family_name = first_family_name;
    record.second_family_name = second_family_name;

    if (record.store) {
      record.store.first_name = first_name;
      record.store.second_name = second_name;
      record.store.first_family_name = first_family_name;
      record.store.second_family_name = second_family_name;
    }
    if (record.active) {
      record.active.first_name = first_name;
      record.active.second_name = second_name;
      record.active.first_family_name = first_family_name;
      record.active.second_family_name = second_family_name;
    }
  }

  return {
    first_name,
    second_name,
    first_family_name,
    second_family_name,
  };
}

export function validateIdNumber(idNumber, typeDocument) {
  const clean = idNumber ? String(idNumber).replace(/[\s.\-]/g, "") : "";
  switch (typeDocument) {
    case "11":
    case "12":
    case "13":
    case "91":
      return /^\d{1,10}$/.test(clean);
    case "22":
      return /^\d{6,7}$/.test(clean);
    case "31":
      return /^\d{9}$/.test(clean);
    case "41":
      return /^[A-Z]{3}\d{6}$/.test(clean);
    case "47":
      return /^\d{15}$/.test(clean);
    default:
      return true;
  }
}

export const isValidEmail = (email) => {
  if (!email || typeof email !== "string") return false;
  const clean = email.replace(/[\s]/g, "");
  return /^(?=.{1,81}$)[\w\.-]+@[\w\.-]+\.\w{2,4}$/.test(clean);
};
export const isValidPhone = (phone) => {
  if (!phone || typeof phone !== "string") return false;
  const digits = phone.replace(/[\s()\-+.]+/g, "");
  return /^\d{7,15}$/.test(digits);
};

export const isValidName = (name) => {
  if (!name || typeof name !== "string") return false;
  return /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s'&.-]{2,50}$/.test(name.trim());
};

export const isValidAddress = (street) => {
  if (!street || typeof street !== "string") return false;
  return /^([a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑ.,#-]+)$/.test(street.trim());
};

export function normalizeDate(value) {
  if (!value) return null;

  if (value instanceof Date) {
    if (isNaN(value.getTime())) return null;
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  if (typeof value === "string") {
    if (value.includes("T")) {
      return value.split("T")[0];
    }
    if (value.includes(" ")) {
      return value.split(" ")[0];
    }
    if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return value;
    }
  }

  return null;
}

export function parseManualDate(input) {
  if (!input) return null;

  const cleaned = input.trim();
  const patterns = [
    /^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/, // dd/mm/yy o dd/mm/yyyy
    /^(\d{4})[/-](\d{1,2})[/-](\d{1,2})$/, // yyyy/mm/dd o yyyy-mm-dd
    /^(\d{1,2})[/-](\d{1,2})$/, // dd/mm
  ];

  for (const pattern of patterns) {
    const match = cleaned.match(pattern);
    if (match) {
      let day, month, year;

      if (pattern === patterns[0]) {
        day = parseInt(match[1]);
        month = parseInt(match[2]);
        year = parseInt(match[3]);

        if (year < 100) {
          if (year >= 48) {
            year = 1900 + year;
          } else {
            year = 2000 + year;
          }
        }
      } else if (pattern === patterns[1]) {
        year = parseInt(match[1]);
        month = parseInt(match[2]);
        day = parseInt(match[3]);
      } else if (pattern === patterns[2]) {
        day = parseInt(match[1]);
        month = parseInt(match[2]);
        const currentDate = new Date();
        year = currentDate.getFullYear();
      }

      if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        const date = new Date(year, month - 1, day);
        if (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        ) {
          return normalizeDate(date);
        }
      }
    }
  }
  return null;
}

export async function fetchClientDian(record) {
  const raw = record.active.id_number ?? record.store.id_number;
  const idNumber = raw ? String(raw).replace(/[\s.\-]/g, "") : null;
  const typeDocObj = record.active.type_document ?? record.store.type_document;
  if (!idNumber || !typeDocObj) return { found: false };
  const typeDoc = typeDocObj?.id ?? typeDocObj;

  const { data, error } = await proxy.methodCall({
    model: "party.party",
    method: "get_client_dian",
    args: [idNumber, typeDoc],
  });

  if (error) return { found: false, error };
  if (!data) return { found: false };
  if (data?.StatusCode !== "200")
    return { found: false, message: data.Message };

  const name = data.ReceiverName?.toUpperCase?.() ?? "";
  const email = data.ReceiverEmail ?? "";

  splitFullName(name, record);

  if (email) {
    record.store.main_email = email;
    record.active.main_email = email;
  }

  return { found: true };
}

export function withDebounce(fn, delay = 500) {
  let timer;
  let lastRequest = 0;

  return async (...args) => {
    const request = ++lastRequest;
    clearTimeout(timer);
    await new Promise((resolve) => {
      timer = setTimeout(resolve, delay);
    });
    // Ignore if a newer call was made during the debounce delay
    if (request !== lastRequest) return;
    const result = await fn(...args);
    // Ignore stale results from previous async calls
    if (request !== lastRequest) return;
    return result;
  };
}

const LOCATION_FIELDS = ["country", "subdivision", "city_co", "city"];

export async function locationToAddress(values) {
  if (!values?.id || values.id < 0) return;
  const keys = LOCATION_FIELDS.filter((key) => key in values);
  if (!keys.length) return;

  const { data } = await proxy.search(
    "party.address",
    [["party", "=", values.id]],
    ["id"],
    1,
  );
  const addressId = data?.[0]?.id;
  if (!addressId) return;

  const addressValues = {};
  for (const key of keys) {
    addressValues[key] = values[key];
    delete values[key];
  }
  values.addresses = [["write", [addressId], addressValues]];
}
